const ReportActionTypes = {
  FETCH_REPORTS_START: "FETCH_REPORTS_START",
  FETCH_REPORTS_SUCCESS: "FETCH_REPORTS_SUCCESS",
  FETCH_REPORTS_FAILURE: "FETCH_REPORTS_FAILURE",
  SET_CURRENT_REPORT: "SET_CURRENT_REPORT",
  SET_CURRENT_REPORT_BY_ID: "SET_CURRENT_REPORT_BY_ID",
  SAVE_REPORT_START: "SAVE_REPORT_START",
  SAVE_REPORT_SUCCESS: "SAVE_REPORT_SUCCESS",
  SAVE_REPORT_FAILURE: "SAVE_REPORT_FAILURE",
  RATE_REPORT_START: "RATE_REPORT_START",
  RATE_REPORT_SUCCESS: "RATE_REPORT_SUCCESS",
  RATE_REPORT_FAILURE: "RATE_REPORT_FAILURE",
  ADD_REPORT: "ADD_REPORT",
  GET_USER_RATING_START: "GET_USER_RATING_START",
  GET_USER_RATING_SUCCESS: "GET_USER_RATING_SUCCESS",
  GET_USER_RATING_FAILURE: "GET_USER_RATING_FAILURE",
};

export default ReportActionTypes;
